import { useSearchDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { parse } from 'query-string';
import { handleErrors, HTTP_CODE } from '../../utils/redirector-utils';


function containsBlacklistedQueryParams(originalPath) {
  const queryStr = originalPath.split('?')[1];
  if (!queryStr) return false;
  const BLACKLIST = ['articles', 'services'];
  const params = parse(queryStr);
  return (params.contentType && BLACKLIST.includes(params.contentType));
}

export function getBrowseSearchRules({
  path, queryParams, keyword, navParam, nttKeyword, response, batchDomains = false
}) {
  let data;
  let loading;
  let error;
  let modifiedKeyword = keyword || nttKeyword;

  if (!response) {
    ({
      data,
      error,
      loading
    } = useSearchDeprecated({
      keyword: modifiedKeyword,
      navParam,
      pageSize: 1,
      domains: ['metadata', 'searchReport', 'products', 'relatedResults'],
      batchDomains,
      ssr: true
    }));
  }

  if (response) {
    ({ data, error, loading } = response);
  }

  if (!data && loading) return { loading };

  const errors = handleErrors(error);

  if (errors) {
    return errors;
  }

  if (((keyword || navParam || nttKeyword) && !data?.searchModel)
    || (!data && !error && !keyword && !navParam && !nttKeyword)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND
    };
  }

  const { canonicalUrl, searchRedirect, analytics } = data?.searchModel?.metadata || {};


  if (searchRedirect) {
    return {
      shouldRedirect: true,
      // eslint-disable-next-line max-len
      redirectPath: `${searchRedirect}&searchRedirect=${keyword}&semanticToken=${encodeURIComponent(analytics?.semanticTokens)}`,
      httpCode: HTTP_CODE.PERM_REDIRECT
    };
  }

  if (/^\/s\//.test(path)) {
    const { totalProducts, didYouMean, correctedKeyword } = data?.searchModel?.searchReport || {};
    const { universalSearch, relatedServices } = data?.searchModel?.relatedResults || {};
    const { identifiers } = data?.searchModel?.products?.[0] || {};

    if (totalProducts === 1
      && !relatedServices?.length
      && !universalSearch
      && !didYouMean
      && !correctedKeyword
      && !containsBlacklistedQueryParams(path)) {
      return {
        shouldRedirect: true,
        redirectPath: identifiers?.canonicalUrl,
        httpCode: HTTP_CODE.TEMP_REDIRECT
      };
    }
  }

  const canonicalPath = (canonicalUrl || '').split('?')[0];

  if (path !== canonicalPath) {
    if (/Ntt-/.test(path)) {
      return {
        shouldRedirect: false,
        httpCode: HTTP_CODE.OK
      };
    }
    if (/^\/s/.test(path)) {
      return {
        shouldRedirect: false,
        httpCode: HTTP_CODE.OK
      };
    }
    if (/Hide-Unavailable-Products/.test(path) && RegExp(navParam).test(canonicalPath)) {
      return {
        shouldRedirect: false,
        httpCode: HTTP_CODE.OK
      };
    }
    return {
      shouldRedirect: true,
      redirectPath: canonicalUrl,
      httpCode: HTTP_CODE.PERM_REDIRECT
    };
  }

  return {
    shouldRedirect: false,
    httpCode: HTTP_CODE.OK
  };
}


export const useBrowseSearchRedirectRules = (props) => {
  return getBrowseSearchRules({ ...props, batchDomains: true });
};
